export default __webpack_public_path__ + "static/21-f22fd33ff3f2b21922a1e4e528e94b67.jpg";